import type { ContractsValueObjectsAmountStrategyTypeEnum } from 'generated/resources/graphql'

const FIXED_AMOUNT_STRATEGY: ContractsValueObjectsAmountStrategyTypeEnum =
  'contracts_fixed_amount_strategy'
const VARIABLE_AMOUNT_STRATEGY: ContractsValueObjectsAmountStrategyTypeEnum =
  'contracts_variable_amount_strategy'
const PER_WORKED_DAY_STRATEGY: ContractsValueObjectsAmountStrategyTypeEnum =
  'contracts_per_worked_day_amount_strategy'

export { FIXED_AMOUNT_STRATEGY, PER_WORKED_DAY_STRATEGY, VARIABLE_AMOUNT_STRATEGY }
